import React, { createContext, useState } from "react";

const LocalContext = createContext();

const LocalContextProvider = (props) => {
  const [showContactFormDialog, setShowContactFormDialog] = useState(false);
  const [showRequestFormDialog, setShowRequestFormDialog] = useState(false);
  const [showRequestAccountFormDialog, setShowRequestAccountFormDialog] = useState(false);
  const [showServicesMenu, setShowServicesMenu] = useState(false);
  const [expandedServices, setExpandedServices] = useState(false);
  const [userHasScrolled, setUserHasScrolled] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  return (
    <LocalContext.Provider
      value={{
        showContactFormDialog, 
        setShowContactFormDialog,
        showRequestFormDialog, setShowRequestFormDialog,
        showRequestAccountFormDialog, setShowRequestAccountFormDialog,
        dropdownOpen, 
        setDropdownOpen,
        showServicesMenu, 
        setShowServicesMenu,
        expandedServices, setExpandedServices,
        userHasScrolled,
        setUserHasScrolled
      }}
    >
      {props.children}
    </LocalContext.Provider>
  );
};

export { LocalContextProvider };
export default LocalContext;
